module.exports = __webpack_public_path__ + "img/banner01.cc9aa24e.png";